import React, { useState } from "react";
import MultiSelect from "../../Shared/MultiSelect";
import DoubleRangeSlider from "../../Shared/DoubleRangeSlider";
import SingleBarChart from "../../Shared/SingleBarChart";

const FilterBarChart = (props) => {
  const [RangesAreDisplayed, setRangesAreDisplayed] = useState(true);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleChartBtnFilterSelect = (SelectedId) => {
    props.SetStatusIsActive(false);

    props.AppStatusChartBtnIds.map((Id) => {
      document.getElementById(Id).classList.remove("active-action-btn");
    });

    // Applying the selected className
    props.ChartBtnIds.map((Id) => {
      document.getElementById(Id).classList.remove("active-action-btn");
    });
    document.getElementById(SelectedId).classList.add("active-action-btn");

    // saving the selected type on the main (parent component)
    let SelectedType = "Vacancies";
    if (SelectedId === props.ChartBtnIds[1]) {
      SelectedType = "Projects";
    } else if (SelectedId === props.ChartBtnIds[2]) {
      SelectedType = "Activities";
    }
    props.SaveSelectedJPAType(SelectedType);

    props.FetchData(5, 0, SelectedType);
  };

  const clearFilters = () => {
    if (document.getElementById("city-clear")) {
      document.getElementById("city-clear").click();
    }
    if (document.getElementById("language-clear")) {
      document.getElementById("language-clear").click();
    }
    setRangesAreDisplayed(false);
    setTimeout(() => {
      setRangesAreDisplayed(true);
    }, 10);

    props.Clear();
    props.ResetTableData();
    props.SetResetIsActive(false);
  };

  const handleFilterSelected = () => {
    props.SetResetIsActive(true);

    let SelectedType = "Vacancies";
    props.ChartBtnIds.map((Id) => {
      if (document.getElementById(Id).classList.contains("active-action-btn")) {
        if (Id === props.ChartBtnIds[1]) {
          SelectedType = "Projects";
        } else if (Id === props.ChartBtnIds[2]) {
          SelectedType = "Activities";
        }
      }
    });

    setTimeout(() => {
      props.GetSingleBarChartData();
    }, 500);
    props.FetchData(5, 0, SelectedType);
  };

  return (
    <div className="filter-chart-wrapper">
      <h3 className="section-title">{translateText("available_jpas_title")}</h3>
      <section
        className="is-mobile mobile-filter-trigger"
        onClick={() => props.HandleMobileFilterMenu()}
      >
        <i className="feather-filter"></i>
        <h3>{translateText("filters")}</h3>
        {props.ActiveFilterCount === 0 ? null : (
          <span className="active-filter-count">
            {"(" + props.ActiveFilterCount + " activated)"}
            <i className="feather-x-circle"></i>
          </span>
        )}
      </section>
      <section className="chart-wrapper">
        <SingleBarChart
          Data={[
            props.AvailableJobs,
            props.AvailableProjects,
            props.AvailableActivities,
          ]}
        />
        <section className="buttons-wrapper">
          <span
            id="jobs-btn"
            onClick={() => handleChartBtnFilterSelect("jobs-btn")}
            className="chart-action active-action-btn"
          >
            {translateText("vacancies")}
          </span>
          <span
            id="proj-btn"
            onClick={() => handleChartBtnFilterSelect("proj-btn")}
            className="chart-action"
          >
            {translateText("projects")}
          </span>
          <span
            id="act-btn"
            onClick={() => handleChartBtnFilterSelect("act-btn")}
            className="chart-action"
          >
            {translateText("activities")}
          </span>
        </section>
      </section>
      {window.innerWidth > 450 ? (
        <section className="filters-wrapper">
          <h3 className="filters-label">{translateText("filters")}</h3>
          <span
            className={
              props.ResetIsActive ? "clear-all" : "clear-all clear-all-disabled"
            }
            id="clear-btn"
            onClick={() => clearFilters()}
          >
            {translateText("clear_all")}
          </span>
          <section className="select-filters">
            <div className="dropdown-holder">
              <p className="dropdown-label">{translateText("location")}</p>
              <MultiSelect
                Initial={translateText("all_cities")}
                Options={props.AllLocations}
                IsWithId
                Id={"city"}
                PreSelectedId=""
                ChangeHandler={() => handleFilterSelected()}
              />
            </div>
            <div className="dropdown-holder">
              <p className="dropdown-label">{translateText("language")}</p>
              <MultiSelect
                Initial={translateText("all_languages")}
                Options={props.AllLanguages}
                IsWithId
                Id={"language"}
                PreSelectedId=""
                ChangeHandler={() => handleFilterSelected()}
              />
            </div>
          </section>
          {RangesAreDisplayed ? (
            <section className="range-filters">
              <DoubleRangeSlider
                MinValue={0}
                MaxValue={props.MaxLikes}
                Title={translateText("number_of_likes")}
                HandleChange={() => handleFilterSelected()}
                Id="likes"
              />
              <DoubleRangeSlider
                MinValue={0}
                MaxValue={props.MaxBookmarks}
                Title={translateText("number_of_bookmarks")}
                HandleChange={() => handleFilterSelected()}
                Id="bookmarks"
              />
              <DoubleRangeSlider
                MinValue={0}
                MaxValue={props.MaxApps}
                Title={translateText("number_of_applications")}
                HandleChange={() => handleFilterSelected()}
                Id="apps"
              />
            </section>
          ) : null}
        </section>
      ) : null}
    </div>
  );
};

export default FilterBarChart;
